import { MoneyDTO } from "../apiclient/ApiDtos";

let usdFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});

let mmkFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'MMK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});
/* let formatMoney = (money: MoneyDTO) => {
    if (money.currency == "MMK") {
        return mmkFormatter.format(money.amount);
    } else if (money.currency == "USD") {
        return usdFormatter.format(money.amount);
    }
    return "N/A";
} */

export function formatMoney(money: MoneyDTO, withCurrency = true) {    
    return ((withCurrency)? money.currency.toLocaleUpperCase() + " " : "") + 
        (new Intl.NumberFormat('en-US').format(money.amount));    
}